export default __webpack_public_path__ + "static/media/ROAMES Analytics - Quick Start Guide.b7116c2f.pdf";